export enum ApiFailCode {
    NOT_AUTHENTICATED = 'Not authenticated',
    GROUP_ROLE_REQ_FOR_ROUTE = 'GROUP_ROLE_REQ_FOR_ROUTE',
}